import {getURLParameter} from '../utils';
import CustomSelect from '../components/custom-select';

const customSelect = new CustomSelect();

const sortFunctions = {
    'a-z': function (a, b) {
        const dataA = a.getAttribute(`data-name`);
        const dataB = b.getAttribute(`data-name`);

        if (dataA < dataB) 
            return -1; 
        if (dataA > dataB) 
            return 1; 
        return 0; 
    },
    'numeric': function (a, b) {
        const dataA = a.getAttribute(`data-number`);
        const dataB = b.getAttribute(`data-number`);

        return dataB - dataA;
    },
    popular (a, b) {
        const dataA = a.getAttribute(`data-popular`);
        const dataB = b.getAttribute(`data-popular`);

        return dataA - dataB;
    },
};

export default class HowToLanding {
    constructor() {
        console.info('HowToLanding.constructor()');

        this.el = {
            categoryFilterForm: document.querySelector('.js-category-filter-form'),
            sortSelect: document.querySelector('.js-sort-select'),
            sortBy: null,
            clearButton: document.querySelector('.js-clear-filters'),
            toggleFiltersButton: document.querySelector('.js-open-filters'),
            closeFiltersButton: document.querySelector('.js-close-filters'),
            applyFiltersButton: document.querySelector('.js-apply-filters'),
            filterMenu: document.querySelector('.js-filter-menu'),
        }
    }

    init() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.init()');
        }

        customSelect.customizeSelects();
        this.el.sortBy = this.el.sortSelect.value;
        this.sortSections();
        this.checkURL();

        const accordionToggles = document.querySelectorAll(".js-section-toggle");
        accordionToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                console.info('Toggle!');

                toggle.parentNode.classList.toggle('is-closed');
            });
        });


        const checkboxes = document.querySelectorAll("input[name=category-checkbox]");
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                this.toggleCategories();
                this.el.applyFiltersButton.removeAttribute('disabled');
            });
        });

        const surfaceCheckboxes = document.querySelectorAll("input[name=surface-checkbox]");
        surfaceCheckboxes.forEach((surfaceCheckbox) => {
            surfaceCheckbox.addEventListener('change', () => {
                this.toggleSurfaces();
                this.el.applyFiltersButton.removeAttribute('disabled');
            });
        });

        this.el.clearButton.addEventListener('click', () => {
            this.clearFilters();
        });

        this.el.sortSelect.addEventListener('change', () => {
            this.el.sortBy = this.el.sortSelect.value;
            this.sortSections();
        });

        this.el.toggleFiltersButton.addEventListener('click', () => {
            this.el.filterMenu.classList.toggle('is-active');
            this.el.applyFiltersButton.setAttribute('disabled', true);
        });

        this.el.closeFiltersButton.addEventListener('click', () => {
            this.el.filterMenu.classList.remove('is-active');
            this.el.applyFiltersButton.setAttribute('disabled', true);
        });

        this.el.applyFiltersButton.addEventListener('click', () => {
            this.el.filterMenu.classList.remove('is-active');
            this.el.applyFiltersButton.setAttribute('disabled', true);
        });
    }

    checkURL() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.checkURL()');
        }

        const categoryParam = getURLParameter('category');
        const surfaceParam = getURLParameter('surface');

        if (categoryParam) {
            const checkbox = document.querySelector(`input[data-category='${categoryParam}']`);

            if (checkbox) {
                checkbox.click();
                this.toggleCategories();
            }
        }

        if (surfaceParam) {
            const checkbox = document.querySelector(`input[data-surface='${surfaceParam}']`);

            if (checkbox) {
                checkbox.click();
                this.toggleSurfaces();
            }
        }
    }

    toggleCategories() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.toggleCategories()');
        }

        const checkboxes = document.querySelectorAll("input[name=category-checkbox]");
        const checkedboxes = document.querySelectorAll('input[name=category-checkbox]:checked').length;

        if (checkedboxes > 0) {
            checkboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    const value = checkbox.getAttribute('data-category');
                    const section = document.querySelector(`.js-category-section[data-category=${value}]`);
                    section.classList.remove('is-hidden');
                    section.classList.add('is-active');
                } else {
                    const value = checkbox.getAttribute('data-category');
                    const section = document.querySelector(`.js-category-section[data-category=${value}]`);
                    section.classList.remove('is-active');
                    section.classList.add('is-hidden');
                }
            });
        } else {
            this.countSectionArticles();
        }

        setTimeout(() => {
            this.calculateSurfaceCounts();
        }, "500");
    }

    toggleSurfaces() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.toggleSurfaces()');
        }

        const checkboxes = document.querySelectorAll("input[name=surface-checkbox]");
        const checkedboxes = document.querySelectorAll('input[name=surface-checkbox]:checked').length;

        if (checkedboxes > 0) {
            checkboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    const value = checkbox.getAttribute('data-surface');
                    const tiles = document.querySelectorAll(`.js-article-tile`);

                    tiles.forEach((tile) => {
                        if (tile.classList.contains(`surface--${value}`)) {
                            tile.classList.remove('is-hidden');
                            tile.classList.add('is-active');
                        } else {
                            tile.classList.remove('is-active');
                            tile.classList.add('is-hidden');
                        };
                    });
                }
            });
        } else {
            const tiles = document.querySelectorAll('.js-article-tile');

            tiles.forEach((tile) => {
                tile.classList.remove('is-hidden');
                tile.classList.add('is-active');
            });
        }

        setTimeout(() => {
            this.calculateSectionCounts();
            this.calculateSurfaceCounts();
        }, "500");
    }

    calculateSectionCounts() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.calculateCategoryCounts()');
        }

        const sections = document.querySelectorAll('.js-category-section');

        sections.forEach((section) => {
            const sectionLength = section.querySelectorAll('.js-article-tile.is-active').length;

            // section.querySelector('.js-section-count').innerHTML = sectionLength;

            const value = section.getAttribute('data-category');
            const checkbox = document.querySelector(`input[data-category=${value}]`);
            // const counter = checkbox.parentNode.querySelector('.js-item-count');
            // counter.innerHTML = sectionLength;
            
            if (sectionLength > 0) {
                checkbox.parentNode.parentNode.classList.remove('is-hidden');
                checkbox.parentNode.parentNode.classList.add('is-active');
            } else {
                checkbox.parentNode.parentNode.classList.remove('is-active');
                checkbox.parentNode.parentNode.classList.add('is-hidden');
            }

            this.countSectionArticles();
        });
    }

    calculateSurfaceCounts() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.calculateSurfaceCounts()');
        }
        
        const sections = document.querySelectorAll('.js-category-section:not(.is-hidden)');
        const checkboxes = document.querySelectorAll("input[name=surface-checkbox]");

        checkboxes.forEach((checkbox) => {
            const value = checkbox.getAttribute('data-surface');
            const tilesArray = [];

            sections.forEach((section) => {
                const tiles = section.querySelectorAll(`.js-article-tile:not(.is-hidden).surface--${value}`);
                
                tiles.forEach((tile) => {
                    tilesArray.push(tile.getAttribute('data-id'));
                });
            });

            const count = tilesArray.filter((tile, index) => tilesArray.indexOf(tile) === index).length;
            if (count > 0) {
                checkbox.parentNode.parentNode.classList.remove('is-hidden');
                checkbox.parentNode.parentNode.classList.add('is-active');
            } else {
                checkbox.parentNode.parentNode.classList.remove('is-active');
                checkbox.parentNode.parentNode.classList.add('is-hidden');
            }
        });
    }

    sortSections() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.sortSections()');
        }

        const sections = document.querySelectorAll('.js-category-section');

        sections.forEach((section) => {
            const articles = section.querySelectorAll('article');
            const articlesArray = Array.from(articles); 
            const sorted = articlesArray.sort(sortFunctions[this.el.sortBy]); 

            sorted.forEach(e => 
                section.querySelector(".section__grid").appendChild(e)); 
        });
    }

    countSectionArticles() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.countSectionTiles()');
        }

        const sections = document.querySelectorAll('.js-category-section');
        const checkedCategoryBoxes = document.querySelectorAll('input[name=category-checkbox]:checked').length;

        if (checkedCategoryBoxes === 0) {
            sections.forEach((section) => {
                const sectionLength = section.querySelectorAll('.js-article-tile:not(.is-hidden)').length;

                if (sectionLength === 0) {
                    section.classList.remove('is-active');
                    section.classList.add('is-hidden');
                } else {
                    section.classList.remove('is-hidden');
                    section.classList.add('is-active');
                }
            });
        }
    }

    clearFilters() {
        if (Electro.DEBUG) {
            console.info('HowToLanding.clearFilters()');
        }

        const checkboxes = document.querySelectorAll("input.item__input[type=checkbox]");

        console.info('checkboxes: ', checkboxes);

        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });

        this.toggleCategories();
        this.toggleSurfaces();
    }
}